import { Briefcase, Droplet, Layers, Leaf, Sparkles, type LucideIcon } from 'lucide-react';

// Heuristic match on service name until the backend exposes a category/iconKey
// (see docs/PLANNING_BACKEND_CHANGES.md).
export function getServiceIcon(serviceName: string | null | undefined): LucideIcon {
  const s = (serviceName ?? '').toLowerCase();
  if (s.includes('unterhalts')) return Sparkles;
  if (s.includes('sanit')) return Droplet;
  if (s.includes('stiegen') || s.includes('treppen')) return Layers;
  if (s.includes('grün') || s.includes('grun') || s.includes('garten')) return Leaf;
  return Briefcase;
}
